import { render } from "./InvoiceFileUpload.vue?vue&type=template&id=481f395e"
import script from "./InvoiceFileUpload.vue?vue&type=script&lang=js"
export * from "./InvoiceFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__